import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "operation-record" }

import { ref, computed, withDefaults } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  XrkTableRef,
  useSelectColumn
} from 'xrk-components';
import { auditRecordList } from '../data-source/apis';
import { formatter } from '@/utils';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'operation-record',
  props: {
    taskRecordId: { default: null }
  },
  setup(__props: any) {

const store = useProjectDetailStore();
const projectInfo = computed(() => store.baseData.projectInfo);
const xrkTableRef = ref<XrkTableRef>();

const props = __props;

const projectId = computed<number>(() => {
  return projectInfo.value.id;
});
// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置'
  },
  searchColumns: [
    useSelectColumn({
      prop: 'auditStatus',
      label: '操作状态',
      config: {
        placeholder: '请选择操作状态',
        options: {
          2: { label: '审核通过', value: '2' },
          3: { label: '审核未通过', value: '3' }
        }
      }
    }),
    useSelectColumn({
      prop: 'operateRole',
      label: '操作方',
      config: {
        placeholder: '请选择操作方',
        options: {
          1: { label: '服务商', value: '1' },
          2: { label: 'OSS平台运营', value: '2' }
        }
      }
    })
  ]
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号'
    }),
    useTableColumn({
      label: '操作时间',
      prop: 'createAt',
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '操作状态',
      prop: 'auditStatus',
      formatter: ({ cellValue }) =>
        ({ 2: '审核通过', 3: '审核未通过' }[+cellValue])
    }),
    useTableColumn({
      label: '操作原因',
      prop: 'remarks',
      formatter: ({ cellValue }) => cellValue || '-'
    }),
    useTableColumn({
      label: '审核方',
      prop: 'operateRole',
      formatter: ({ cellValue }) =>
        ({ 1: '服务商', 2: 'OSS平台运营' }[cellValue])
    })
  ]
});

const getListAjax = async params => {
  const data = await auditRecordList({
    ...params,
    taskRecordId: props.taskRecordId,
    projectId: projectId.value,
    sceneType: projectInfo.value.sceneType
  });
  return data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})